import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const jobPhasesModule = {
  namespaced: true,
  state() {
    return {
      jobPhases: [],
    };
  },
  actions,
  getters,
  mutations,
};

export default jobPhasesModule;
